export default __webpack_public_path__ + "static/media/UTENTE_questionario.6c50449c.png";